<template>
  <div ref="dialogIndex" class="dialog__body--custom">
    <div v-if="showImg" class="dialog__img">
      <div class="hint">
        <slot name="icon">
          <img v-if="imgUrl" :src="require(`@/assets/images/${imgUrl}`)" :alt="imgUrl" />
          <svg-icon v-if="imgIcon" :icon-class="imgIcon" />
        </slot>
      </div>
    </div>
    <div class="dialog__content">
      <slot name="content">
        <div v-if="content.title" class="title weightText">{{ content.title }}</div>
        <div class="desc primaryText">
          {{ content.desc || $t(defDesc) }}
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "RcDialogIndex",
  props: {
    showImg: {
      type: Boolean,
      default: true
    },
    imgIcon: {
      type: String,
      // 删除：hint, 成功：success，重置：reset
      default: "hint"
    },
    imgUrl: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => ({})
    },
    defDesc: {
      type: String,
      default: "public.cannotRecovered"
    }
  },
  computed: {
    refs() {
      return this.$refs.dialogIndex;
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog__body--custom {
  display: flex;
  flex-direction: row;
  .dialog__img {
    .hint {
      text-align: center;
      color: #ff6417;
      font-size: 30px;
      margin-top: -4px;
    }
  }
  .dialog__content {
    .title {
      line-height: 26px;
      font-size: 16px;
      font-weight: 600;
    }
    .desc {
      padding: 10px 0;
      line-height: 20px;
      min-height: 80px;
    }
  }
}
</style>
